import activityTypeMapping from '../generated/shared_data/activityTypeLegacyToLscriptUnits.json';
import lscriptToPipelineV2UnitsJson from '../generated/shared_data/lscriptToPipelineV2Units.json';

// lscriptToPipelineV2UnitsJson and activityTypeMapping are generated with
// ./scripts/codegen typescript. If you want to add a mapping, navigate to
// py/watershed/shared_data/*.json.

/**
 * Maps Lscript units to legacy units supported by pipeline v2, as defined in
 * shared_data/units.json.
 */
export const lscriptToPipelineV2Units = new Map<string, string>(
  Object.entries(lscriptToPipelineV2UnitsJson)
);

/**
 * For each activity type + unit column, maps a legacy unit to its LScript
 * equivalent. Sectioning by activity type allows us to handle legacy units that
 * are have context-dependent meanings (e.g. "oz" can be represent either ounce
 * or fluid_ounce).
 */
export type ActivityTypeLegacyMapping = {
  [activityType: string]: {
    [unitCol: string]: {
      [batUnit: string]: string;
    };
  };
};
export const activityTypeLegacyMapping: ActivityTypeLegacyMapping =
  activityTypeMapping;
